import script from "./ReadingHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadingHistory.vue?vue&type=script&setup=true&lang=js"

import "./ReadingHistory.vue?vue&type=style&index=0&id=36f0dd56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f0dd56"]])

export default __exports__